import { InitializationService } from 'src/utils/initialization.service';
import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { NgxPermissionsGuard } from "ngx-permissions";
import { Observable } from "rxjs";
import { AuthenticationService } from "../services/authentication.service";
import { Role } from "../models/roles-permissions.model";

@Injectable({
  providedIn: "root",
})
export class RoleGuard  {
  private router = inject(Router);
  private permissionGuard = inject(NgxPermissionsGuard);
  private authService = inject(AuthenticationService);
  private initializationService = inject(InitializationService);


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const requestData: any = {
      ...route,
      data: {
        permissions: {
          only: route?.data?.roles?.only,
        },
      },
    };
    const guard = this.permissionGuard.canActivate(
      requestData,
      state
    ) as Promise<boolean>;
    return guard.then((data) => {
      if (!data) {
        this.authService.getPermissions().subscribe((perm: Object) => {
          if (
            (perm.hasOwnProperty(Role.Guest) || perm.hasOwnProperty(Role.Customer) || perm.hasOwnProperty(Role.BusinessCustomer) &&
              !this.initializationService.getCurrentUrl().includes('localhost:4200'))
          ) {
            this.router.navigate(["/home/main-dashboard"]);
          } else if (perm.hasOwnProperty(Role.Vendor) || perm.hasOwnProperty(Role.WholeSaler)) {
            this.router.navigate(["/vendor/dashboard"]);
          } else if (perm.hasOwnProperty(Role.SiteAdministrator) || perm.hasOwnProperty(Role.SuperAdministrator)) {
            this.router.navigate(["/admin/dashboard"]);
          } else {
            this.router.navigate([route.data?.roles?.redirectTo]);
          }
        });
      } else {
        return data;
      }
    });
  }
}
